import { debounce } from 'lodash';
import qs from 'query-string';
import React from 'react';
import { hot } from 'react-hot-loader';

export default hot(module)(
	class Filter extends React.Component {
		constructor(props) {
			super(props);
			this.state = {
				_searchtext: ''
			};
		}

		debouncedOnSearch = debounce(value => {
			this.props.onSearch(value);
		}, 800);

		onSearch = e => {
			const value = e.target.value;
			this.setState({ _searchtext: value });
			this.debouncedOnSearch(value);
		};

		onReset = async () => {
			this.setState({
				_searchtext: ''
			});
			this.props.onResetFilter();
		};

		retainStateFromQueryUrl = async () => {
			const query = qs.parse(window.location.search);
			await this.setState({
				_searchtext: query.globalSearch || ''
			});
			this.props.onSearch(query.globalSearch || '', false);
		};

		componentDidMount() {
			this.retainStateFromQueryUrl();
		}

		render() {
			return (
				<div className="row" style={{ marginBottom: '30px', marginTop: '20px' }}>
					<div className="col-8">
						<input
							className="form-control"
							onChange={this.onSearch}
							placeholder="Search"
							type="text"
							value={this.state._searchtext}
						/>
					</div>
					<div className="col-2">
						<button className="btn btn-block bg-gradient-danger" onClick={this.onReset} type="button">
							Reset
						</button>
					</div>
				</div>
			);
		}
	}
);
